import { ApiCall } from "common/types/api";
import { BulkUpdate } from "common/types/entity-bulk-update";

export const bulkUpdateApi = (apiCall: ApiCall) => ({
  bulkUpdate: (entityName: string, payload: BulkUpdate) =>
    apiCall<void>("put", `api/entities/:site/${entityName}/bulk`, payload),
});
